<template>
  <div  class="main_center" style="margin: 0 0;padding-top: 8px;">
    <div class="content">
      <!-- <el-form ref="form" :model="search" label-width="110px">
        <el-row>
          <el-col :span="6"  >
            <el-form-item label="年份：">
                <el-select v-model="search.year" value-key="value" style="width:100%;"  @change="yearsChange">
                  <el-option v-for="(item,index) in yearsList"
                             :key="index"
                             :label="item"
                             :value="item"></el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-form-item label="名称：" props="projectName" >
              <el-input   v-model="search.projectName" clearable placeholder="请输入内容搜索" @keyup.enter.native="seachBtn" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6"  v-if="moreSearchItem" >
            <el-form-item label="编号：" props="projectCode" >
              <el-input  v-model="search.projectCode" clearable placeholder="请输入内容搜索" @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-form-item label="" v-if="!moreSearchItem">
                <div>
                    <el-button plain size="small" type="primary"  @click="reflash">重置</el-button>
                    <el-button size="small" type="primary"  @click="seachBtn">搜索</el-button>
                    <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true" >| 展开</el-button>
                    <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false" >| 收起</el-button>
                </div>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-form-item label="招标代理机构：" props="tenderAgencyName" v-if="moreSearchItem">
              <el-input  v-model="search.tenderAgencyName" clearable placeholder="请输入内容搜索" @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6"  v-if="moreSearchItem" >
            <el-form-item label="交易中心：">
              <el-select v-model="search.tradeId" clearable value-key="value" style="width:100%;" @change="seachBtn">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(item,index) in transactionCenterList" :key="index" :label="item.orgName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="moreSearchItem">
            <el-form-item label="登记起止时间：">
              <el-date-picker
                      style="width: 100%"
                      v-model="search.datetimerange"
                      @change="seachBtn"
                      type="daterange"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-form-item label="招标人：" props="tendererName" v-if="moreSearchItem">
              <el-input  v-model="search.tendererName" clearable placeholder="请输入内容搜索" @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-form-item label="" v-if="moreSearchItem">
                <div>
                    <el-button plain size="small" type="primary"  @click="reflash">重置</el-button>
                    <el-button size="small" type="primary"  @click="seachBtn">搜索</el-button>
                    <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true" >| 展开</el-button>
                    <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false" >| 收起</el-button>
                </div>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
              <el-button size="small" v-if="deleteBtnShow" icon="el-icon-delete" type="primary"
                         @click="deleteSelectItem()">批量删除
              </el-button>
              <el-button size="small" v-if="deleteBtnShow" icon="el-icon-success" type="primary"
                         @click="selectAll(true)">全选
              </el-button>
              <el-button size="small" v-if="deleteBtnShow" icon="el-icon-success" type="primary"
                         @click="selectAll(false)">反选
              </el-button>
          </el-col>
        </el-row>
      </el-form> -->
      <serach-form ref="searchFormRef" :dataList="formList" :form="search" :moreSearchItem="moreSearchItem"></serach-form>

      <space :left="-16" :right="-16" :bottom="16" />
     <el-row>
        <el-col :span="12">
              <el-button size="small" v-if="deleteBtnShow" icon="el-icon-delete" type="primary"
                         @click="deleteSelectItem()">批量删除
              </el-button>
              <el-button size="small" v-if="deleteBtnShow" icon="el-icon-success" type="primary"
                         @click="selectAll(true)">全选
              </el-button>
              <el-button size="small" v-if="deleteBtnShow" icon="el-icon-success" type="primary"
                         @click="selectAll(false)">反选
              </el-button>
          </el-col>
     </el-row>
      <el-row :gutter="15" :style="{'min-height':tableMaxHeight}"  v-loading="dataListLoading">
        <el-col :span="6" v-for="(item) in tableData" style="min-width: 180px" :key="item.id" >
          <el-card class="projectCard">
            <div slot="header" class="clearfix">
              <!--  dataGroup 2 标段，dataGroup 1 项目 -->
              <span class="title"  :title="item.dataGroup==1?item.project.projectName:item.bid.bidName">{{item.dataGroup==1?item.project.projectName:item.bid.bidName}}</span>
              <p class="ellipsis" style="margin:6px 0px"><span>编号：</span><span :title="item.dataGroup==1?item.project.projectCode:item.bid.bidCode">{{item.dataGroup==1?item.project.projectCode:item.bid.bidCode}}</span></p>
              <p class="deleteBtn" v-if="deleteBtnShow">
                <i :style="{'color':hasSelect(item.id)?'#5cb6ff':'#c0c4cc'}"  @click="triggerSelectItem(item.id)" :class="hasSelect(item.id)?'el-icon-circle-check':'el-icon-circle-close'"></i>
              </p>
            </div>
            <p class="info"><span>招标人：</span><span :title="item.project.tendererName">{{item.project.tendererName}}</span></p>
            <p class="info"><span>招标代理：</span><span :title="item.project.tenderAgencyName">{{item.project.tenderAgencyName}}</span></p>
            <p class="info"><span>登记时间：</span><span>{{formatDate(item.createTime,'yyyy-MM-dd') }}</span></p>
            <p class="info"><span>抽取时间：</span><span :title="formatDate(item.videoStime,'yyyy-MM-dd HH:mm') + '至' + formatDate(item.videoEtime,'HH:mm') ">{{ formatDate(item.videoStime,'yyyy-MM-dd HH:mm') }} 至 {{formatDate(item.videoEtime,'HH:mm') }} </span></p>
            <div class="btnWrapper" v-if="hasBtnPermission('btn_jz_witness_record_show')">
              <el-button  size="mini" type="text"  @click="router(item)">查看 >> </el-button>
            </div>
          </el-card>
        </el-col>
        <emptyInfo v-if="tableData.length == 0" :emptyMsg="'暂无记录数据'" ></emptyInfo>
      </el-row>
      <!-- <el-pagination background layout="prev, pager, next" :page-size="pageSize" :total="total" :current-page="pageIndex"  ></el-pagination> -->
      <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange">
        </pagination>
    </div>
  </div>
</template>

<script>
    import emptyInfo from '@/components/empty-info';
    import {nearSixYearsList} from '@/utils/index';
    import space from '../../../common/components/space.vue';
    import Pagination from '@/components/Pagination.vue';
    import SerachForm from "@/views/common/components/SerachForm.vue";
    export default {
  components: {
    emptyInfo,
    space,
    Pagination,
    SerachForm
  },
  data() {
    return {
      tableMaxHeight:( document.documentElement.clientHeight - 267 ) + 'px',
      dataListLoading: false,
      yearsList:[],
      moreSearchItem:false,
      deleteBtnShow:false,
      selectDeleteList:[],
      search:{
         year:new Date().getFullYear(),
         projectName:"", //名称
         projectCode:"", //编号
         tenderAgencyName:"", //代理机构名称
         tendererName:"", //招标人
         createTime:"", //登记时间
        tradeId: '', // 交易中心ID
        datetimerange:[]

      },
      datetimerange:[],
      form:{    //见证数据
        id: "",          //见证数据ID
        bidopenTime: "", //开标时间
        businessId: "",  //关联的项目ID
        businessexId: "",//关联的标段ID
        createTime: "",  //创建时间
        createUser: "",  //创建人
        dataGroup: "",   //是否关联项目  1:关联项目  2:关联标段
        dataType: "",    //见证类型     1专家抽取见证 2开标见证 3评标见证
        delFlag: false,
        detailList: [], //见证明细数据
        evalEtime: "",  //评标开始时间
        evalStime: "",  //评标结束时间
        field1: "",
        field2: "",
        field3: "",
        fileTypeDictCode: "",
        fileTypeMap: {},
        historyid: "",  //-1:暂存   0:已生效
        remark: "",     //备注
        updateTime: "", //更新时间
        updateUser: "", //更新用户
        videoEtime: "", //视频结束时间
        videoStime: "", //视频开始时间
        witnessContent: "",
        witnessUserId: "",
        project: {  //项目数据
          id: "",
          projectCode: "",   //项目编号
          projectName: "",   //项目名称
          tenderAgencyName: "", //招标代理机构名称
          tendererName:""   //招标人名称
        },
        bid:{ //标段数据

        },
      },
      pageSize:10,//每页条数
      pageIndex:1,//当前页
      total:0,//总条数
      tableData:[],
      multipleSelection: [],
      user:'', //角色类型
      formData:{},
      transactionCenterList: [],
      formList:[
                {
                    type:'select',
                    propName:'year',
                    labelName:'年份：',
                    optionList:this.yearsList,
                    changeClick:'yearsChange',
                    isShow:true
                },
                {
                    type:'input',
                    propName:'projectName',
                    labelName:'名称：',
                    isShow:true
                },
                {
                    type:'input',
                    propName:'projectCode',
                    labelName:'编号：',
                    isShow:true
                },
                {
                    type:'input',
                    propName:'tenderAgencyName',
                    labelName:'招标代理机构：',
                    isShow:'close'
                },
                {
                    type:'select',
                    propName:'tradeId',
                    labelName:'交易中心：',
                    optionList:this.transactionCenterList,
                    changeClick:'seachBtn',
                    optionLabel:'orgName',
                    optionValue:'id',
                    isShow:'close'
                },
                {
                    type:'date-picker',
                    propName:'datetimerange',
                    labelName:'登记起止时间：',
                    isShow:'close'
                },
                {
                    type:'input',
                    propName:'tendererName',
                    labelName:'招标人：',
                    isShow:'close'
                },
                {
                    type:'button',
                    optionList:[{
                        typePrimary:'primary',
                        isplain:true,
                        size:'small',
                        handleClick:'reflash',
                        btnText:'重置',
                        isShow:true
                    },{
                        typePrimary:'primary',
                        isplain:false,
                        size:'small',
                        handleClick:'seachBtn',
                        btnText:'搜索',
                        isShow:true
                    },{
                        typePrimary:'text',
                        isplain:false,
                        size:'mini',
                        handleClick:'openSearch',
                        btnText:'| 展开',
                        isShow:'open'
                    },{
                        typePrimary:'text',
                        isplain:false,
                        size:'mini',
                        handleClick:'closeSearch',
                        btnText:'| 收起',
                        isShow:'close'
                    }],
                }
            ],
    }
  },
  watch:{
        yearsList:{
           deep:true,
           handler(val){
                let numberIndex=this.setFormListItem('year')
                if(numberIndex!=null){
                this.formList[numberIndex].optionList= val
                }
           }
        },
        // 交易中心
        transactionCenterList:{
            deep:true,
              handler(val){
                let numberIndex=this.setFormListItem('tradeId')
                if(numberIndex){
                    this.formList[numberIndex].optionList= val
                }
           } 
        },
        moreSearchItem:{
            handler(val){
                this.$nextTick(()=>{
                    let flag=val?'open':'close'
                     this.$refs.searchFormRef.setWidth(flag);
                })
            }
        }
    },
  created() {
    this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
    this.yearsList = nearSixYearsList(this.search.year)
    this.transactionCenterList.unshift({orgName:'全部',id:''})
    // 初始化 只展示前三个元素 + 控制按钮
    this.formList=this.formList.slice(0,3).concat(this.formList.slice(this.formList.length-1,this.formList.length))

  },
  mounted() {
    const that = this;
    let resizeTag = true;
    window.onresize = () => {
      if(resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();

  },

  activated() {

      this.getDataList()
  },
  methods: {
    setFormListItem(strProp){
            let number=null
            this.formList.forEach((item,index)=>{
                if(item.type!='button'&&item.propName===strProp){
                    number=index
                }
            })
            return number
        },
        openSearch(){
           this.moreSearchItem = true
           // 触发数据监听更新数据
           this.formList=[...this.$options.data.call(this).formList]
           this.witnessStatuslist=[...this.witnessStatuslist]
           this.witnessModlist=[...this.witnessModlist]
           this.transactionCenterList=[...this.transactionCenterList]
           this.yearsList=[...this.yearsList]
        },
        closeSearch(){
            this.moreSearchItem = false
            this.formList=this.formList.slice(0,3).concat(this.formList.slice(this.formList.length-1,this.formList.length))
        },
    paginationChange(obj){
        this.pageIndex= obj.page||1
        this.pageSize=obj.limit||10
        this.getDataList();
    },
    ifmove() {


      let hasBtnPermisson = this.hasBtnPermission("btn_jz_witness_record_delete");
      let tableMaxHeight = ( document.documentElement.clientHeight - 320 +  (hasBtnPermisson ? 0 : 33) ) + 'px';
      this.pageIndex = 1
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })
      if(document.documentElement.clientHeight >900){
        this.pageSize = 12
      }else if(document.documentElement.clientHeight < 770){
        this.pageSize = 8
      }else{
        this.pageSize = 8
      }
      // this.getDataList()

    },

    triggerDeleteBtn(){
      this.deleteBtnShow = !this.deleteBtnShow;
      this.selectDeleteList = [];
    },
    hasSelect(id){
      let index = this.selectDeleteList.indexOf(id);
      return index > -1
    },
    triggerSelectItem(id){
      let index = this.selectDeleteList.indexOf(id);
      if(index > -1){
        this.selectDeleteList.splice(index,1);
      }else{
        this.selectDeleteList.push(id)
      }
    },

    selectAll(flag){
      const that = this;
      this.tableData.forEach(item=>{
        let index = that.selectDeleteList.indexOf(item.id)
        if(flag && index == -1){
          that.selectDeleteList.push(item.id)
        }
        if(!flag){
          that.triggerSelectItem(item.id)
        }
      })
    },

    deleteSelectItem() {
      if (this.selectDeleteList.length > 0) {

        this.$confirm(`确定要删除该数据?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post('/tradding/traddingwitness/delete',{
            idList:this.selectDeleteList
          }).then(res => {
            if (res.data.code == '1') {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.getDataList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }
    },


      reflash() {

        this.pageIndex = 1;

        this.$refs['form'].resetFields();
       
        this.search={
          year:new Date().getFullYear(),
          projectName:"", //名称
          projectCode:"", //编号
          tenderAgencyName:"", //代理机构名称
          tendererName:"", //招标人
          createTime:"", //登记时间
          datetimerange:[]
        };
        this.yearsList = nearSixYearsList(this.search.year);
        this.getDataList()
      },
      getDataList(){ // 获取列表数据

        this.form.startTime = this.search.datetimerange && this.search.datetimerange[0]?( this.search.datetimerange[0] + ' 00:00:00' ):"";
        this.form.endTime = this.search.datetimerange && this.search.datetimerange[1]? ( this.search.datetimerange[1] + ' 23:59:59'):"";
        this.dataListLoading=true;
        this.$http.post('/tradding/traddingwitness/list',{
          'page': this.pageIndex,
          'rows': this.pageSize,
          'searchKey': '',
          'filter': {
              "year":this.search.year,
              "businessName":this.search.projectName, //项目名称
              "businessCode":this.search.projectCode,//项目编号
              "tradeId": this.search.tradeId,
              "tenderAgencyName":this.search.tenderAgencyName,//代理机构名称
              "tendererName":this.search.tendererName,//招标人
              'createTimeLT':this.form.endTime,
              'createTimeGE':this.form.startTime,
          }
        }).then(res=>{
          this.dataListLoading=false;
          this.tableData=res.data.rows;
          this.total=res.data.total;


        })
    },

    yearsChange(val){
      this.yearsList = nearSixYearsList(val)
      this.getDataList()
    },
    seachBtn(){ //搜索按钮
      this.pageIndex = 1;
      this.getDataList()
    },

    //路由跳转
    router(item){

      // let routeName ='expertWitness_detail'
      // //跳转到view页面
      // if (item.historyid =='0') {
      //   routeName = 'expertWitness_view';
      // }else{
      //   //跳转到detail页面
      //   routeName='expertWitness_detail'
      // }
      this.$router.push({
        name:'expertWitness_view',
        query:{
          id:item.id,
          dataSource:item.dataSource
        }
      });
    }



  }
}
</script>


<style lang="less" scoped>

  .projectCard{
    /deep/ .el-card__body{
      padding: 0;
    }
    /deep/ .el-card__header{
      padding: 16px 16px 0px 16px;
    }

  }

</style>
